import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { RoutePath } from "../../routes/Routes";
import StateComponents from "../../../components/state-component/StateComponents";
import ContainerLayout from "../../../components/container-layout/ContainerLayout";
import ContainerButton from "../../../components/button/ContainerButton";
import { Box, Card, Grid, Typography } from "@mui/material";
import { icons } from "../../../assets/icons/icons";
import { MENU_RENDER_VIEW_ENUM } from "../website-structure/menu/enum.menu";
import ModalMedia from "../media/modal-media/ModalMedia";
import { MediaApi } from "../../../api/media-file/MediaFile.api";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { introPageApi } from "../../../api/intro-page/intro-page.api";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import moment from "moment";
import { routeName } from "../../../routes/routeName";
import { RootState } from "../../../store/store";
import { checkPermission } from "../../../utils/app.utils";
import { useTranslation } from "react-i18next";
// import { checkPermission, permission_config }

interface FileImageState {
  id: number | null;
  previewUrl: string | null;
  filePath: string | null;
}

interface FileImagesState {
  imageDesktopMain: FileImageState;
  imageDesktopFirst: FileImageState;
  imageDesktopSecond: FileImageState;
  imageMobileMain: FileImageState;
  imageMobileFirst: FileImageState;
  imageMobileSecond: FileImageState;
}

interface UploadCardProps {
  id: string;
  label: string;
  height: number;
  imageSize?: number;
  onUploadClick: (id: string) => void;
  fileId?: number | null;
  previewUrl?: string | null;
}

const UploadCard = ({
  id,
  label,
  height,
  imageSize,
  onUploadClick,
  previewUrl,
}: UploadCardProps) => {
  const { t } = useTranslation();
  return (
  <Card
    variant="outlined"
    sx={{
      borderRadius: 2,
      height: height,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      position: "relative",
      overflow: "hidden",
    }}
    onClick={() => onUploadClick(id)}
  >
    {previewUrl ? (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <img
          src={previewUrl}
          alt="Preview"
          style={{
            minWidth: "100px",
            width: "100%",
            minHeight: "100px",
            height: "100%",
            objectFit: "contain",
          }}
          onError={(e) => {
            console.error("Image failed to load:", previewUrl);
            console.error("event:", e);
            // Optionally set a fallback image or hide the preview
          }}
        />
        <Typography
          variant="caption"
          sx={{
            position: "absolute",
            bottom: 8,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "rgba(0,0,0,0.7)",
            color: "white",
            p: 1,
            borderRadius: 1,
          }}
        >
          {t("คลิกเพื่อเปลี่ยนรูปภาพ")}
        </Typography>
      </Box>
    ) : (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          width: "100%",
          height: "100%",
          p: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 2,
          }}
        >
          <img
            src={icons.addImage}
            alt="upload"
            style={{
              width: imageSize ? imageSize : height - 120,
              height: "auto",
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </Box>

        <Typography variant="body2" sx={{ mb: 1 }}>
          {label}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {t("ภาพ jpg/jpeg/png ขนาดไม่เกิน 10MB")}
        </Typography>
      </Box>
    )}
  </Card>
  );
};

const FormSection = ({
  inputValue,
  setInputValue,
}: {
  inputValue: any;
  setInputValue: React.Dispatch<React.SetStateAction<any>>;
}) => {
  const { t } = useTranslation();
  const handleChangeFormState = (field: string, value: any) => {
    setInputValue((prev: any) => ({ ...prev, [field]: value }));
  };
  return (
    <>
      <StateComponents
        otherProps={{ spacing: 2 }}
        typeProps={[
          {
            seq: 1,
            type: "RADIO",
            gridProps: {
              xs: 12,
            },
            fieldProps: {
              row: true,
              onChange: (e) =>
                handleChangeFormState("banner_status_open", e.target.value),
              value: inputValue.banner_status_open,
              dataList: [
                {
                  label: t("อยู่ในหน้าเดิม"),
                  value: MENU_RENDER_VIEW_ENUM.CURRENT_TAB,
                },
                {
                  label: t("เปิดหน้าใหม่"),
                  value: MENU_RENDER_VIEW_ENUM.NEW_TAB,
                },
              ],
              heading: t("การแสดงผล"),
            },
          },
          {
            seq: 2,
            type: "TEXT_FIELD",
            gridProps: {
              xs: 12,
            },
            fieldProps: {
              heading: t("ข้อความ"),
              placeholder: t("ระบุ"),
              onChange: (e) =>
                handleChangeFormState("banner_name", e.target.value),
              value: inputValue.banner_name,
            },
          },
          {
            seq: 3,
            type: "TEXT_FIELD",
            gridProps: {
              xs: 12,
            },
            fieldProps: {
              heading: t("ลิงก์เชื่อมโยง"),
              placeholder: t("ระบุ"),
              onChange: (e) =>
                handleChangeFormState("banner_link", e.target.value),
              value: inputValue.banner_link,
            },
          },
          {
            seq: 4,
            type: "SELECT",
            gridProps: {
              xs: 12,
            },
            fieldProps: {
              labelId: "banner_position",
              selectId: "banner_position",
              heading: t("ตำแหน่งปุ่ม"),
              value: inputValue?.banner_position,
              onChange: (e) => {
                handleChangeFormState("banner_position", e.target.value);
              },
              options: [
                {
                  label: t("ซ้าย"),
                  value: "LEFT",
                },
                {
                  label: t("กลาง"),
                  value: "CENTER",
                },
                {
                  label: t("ขวา"),
                  value: "RIGHT",
                },
              ],
            },
          },
        ]}
      />
    </>
  );
};

const WelcomePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profileReducer = useSelector((state: RootState) => state.profile.profile);
  const permission: any[] = profileReducer?.permission || [];
  const checkPermit = checkPermission('MANAGE_WEB_SITE_INTRO', permission);
  console.log(checkPermit,'checkPermit')

  const [inputValue, setInputValue] = useState<any>({
    is_public: false,
    intro_name: "",
    intro_start_date: "",
    intro_start_time: "",
    intro_end_date: "",
    intro_end_time: "",
  });

  // File management state with proper typing
  const [fileImages, setFileImages] = useState<FileImagesState>({
    imageDesktopMain: { id: null, previewUrl: null, filePath: null },
    imageDesktopFirst: { id: null, previewUrl: null, filePath: null },
    imageDesktopSecond: { id: null, previewUrl: null, filePath: null },
    imageMobileMain: { id: null, previewUrl: null, filePath: null },
    imageMobileFirst: { id: null, previewUrl: null, filePath: null },
    imageMobileSecond: { id: null, previewUrl: null, filePath: null },
  });

  // Modal state
  const [modalState, setModalState] = useState({
    open: false,
    currentUploadId: "",
  });

  // Form states for each section
  const [inputValueMediaDesktopFirst, setInputValueDesktopFirst] =
    useState<any>({
      banner_status_open: 0,
      banner_name: "",
      banner_link: "",
      banner_position: "",
    });

  const [inputValueMediaDesktopSecond, setInputValueDesktopSecond] =
    useState<any>({
      banner_status_open: 0,
      banner_name: "",
      banner_link: "",
      banner_position: "",
    });

  const [inputValueMediaMobileFirst, setInputValueMobileFirst] = useState<any>({
    banner_status_open: 0,
    banner_name: "",
    banner_link: "",
    banner_position: "",
  });

  const [inputValueMediaMobileSecond, setInputValueMobileSecond] =
    useState<any>({
      banner_status_open: 0,
      banner_name: "",
      banner_link: "",
      banner_position: "",
    });

  // Helper function to get preview URL from file ID
  const linkPreviewImage = async (fileId: number): Promise<string | null> => {
    try {
      const res = await MediaApi.findOneFile(fileId);
      if (res.status < 300 && res.data?.data) {
        const data = res.data.data;
        const baseFileUrl = process.env.REACT_APP_FILE_BASE_API;

        // Ensure we have the required data
        if (data.media_file_path && data.media_file_name) {
          const fullUrl = `${baseFileUrl}/${data.media_file_path}${data.media_file_name}`;
          // console.log("Generated preview URL:", fullUrl);
          return fullUrl;
        }
      }
      return null;
    } catch (error) {
      console.error("Error getting preview image:", error);
      return null;
    }
  };

  // Update file image state helper
  const updateFileImage = (
    uploadId: string,
    fileData: Partial<FileImageState>
  ) => {
    setFileImages((prev) => ({
      ...prev,
      [uploadId]: {
        ...prev[uploadId as keyof FileImagesState],
        ...fileData,
      },
    }));
  };

  const handleChangeInputValue = (field: any, value: any) => {
    setInputValue((prev: any) => ({ ...prev, [field]: value }));
  };

  // Handle upload card click
  const handleUploadClick = (uploadId: string) => {
    setModalState({
      open: true,
      currentUploadId: uploadId,
    });
  };

  // Handle modal close
  const handleCloseModal = () => {
    setModalState({
      open: false,
      currentUploadId: "",
    });
  };

  // console.log(inputValue, 'inputValue')
  // console.log(inputValueMediaDesktopFirst, 'inputValueMediaDesktopFirst')

  // Handle file selection from modal (existing file)
  const handleSelectMediaFile = async (
    id_media: number,
    id_media_file: number | null
  ) => {
    // console.log('id_media', id_media);
    if (id_media_file && modalState.currentUploadId) {
      // console.log("Selecting existing media file:", id_media_file);

      const previewUrl = await linkPreviewImage(id_media_file);

      if (previewUrl) {
        updateFileImage(modalState.currentUploadId, {
          id: id_media_file,
          previewUrl: previewUrl,
          filePath: previewUrl,
        });

        console.log("Updated file image with preview:", previewUrl);
        handleCloseModal();
      } else {
        console.error(
          "Failed to generate preview URL for file:",
          id_media_file
        );
      }
    }
  };

  // Handle file upload completion (new file upload)
  const handleSubmitMediaFile = async (
    _id_media: number,
    id_media_file: number
  ) => {
    if (modalState.currentUploadId) {

      const previewUrl = await linkPreviewImage(id_media_file);

      if (previewUrl) {
        updateFileImage(modalState.currentUploadId, {
          id: id_media_file,
          previewUrl: previewUrl,
          filePath: previewUrl,
        });

        handleCloseModal();
      } else {
        console.error(
          "Failed to generate preview URL for new file:",
          id_media_file
        );
      }
    }
  };

  // Handle local file upload
  const handleSubmitLocalFile = async (id_media: number) => {
    if (modalState.currentUploadId) {

      const previewUrl = await linkPreviewImage(id_media);

      if (previewUrl) {
        updateFileImage(modalState.currentUploadId, {
          id: id_media,
          previewUrl: previewUrl,
          filePath: previewUrl,
        });

        console.log(
          "Updated file image with local upload preview:",
          previewUrl
        );
        handleCloseModal();
      } else {
        console.error(
          "Failed to generate preview URL for local file:",
          id_media
        );
      }
    }
  };

  const handleSubmit = async () => {
    dispatch(setLoading());

    try {
      const { intro_start_date, intro_start_time, intro_end_date, intro_end_time } = inputValue;

      // Combine date and time and convert to ISO format
      const startDateTime = `${intro_start_date}T${intro_start_time}`;
      const endDateTime = `${intro_end_date}T${intro_end_time}`;

      const payload = {
        intro_page_start: startDateTime,
        intro_page_end: endDateTime,
        is_public: inputValue.is_public,
        intro_page_details_create: [
          {
            intro_page_detail_type: "DESKTOP",
            id_media_file_main: fileImages.imageDesktopMain.id,
            id_media_file_button_first: fileImages.imageDesktopFirst.id,
            button_first_name: inputValueMediaDesktopFirst.banner_name,
            button_first_link: inputValueMediaDesktopFirst.banner_link,
            button_first_location: inputValueMediaDesktopFirst.banner_position,
            button_first_is_open:
              inputValueMediaDesktopFirst.banner_status_open === MENU_RENDER_VIEW_ENUM.NEW_TAB,
            id_media_file_button_second: fileImages.imageDesktopSecond.id,
            button_second_name: inputValueMediaDesktopSecond.banner_name,
            button_second_link: inputValueMediaDesktopSecond.banner_link,
            button_second_location:
              inputValueMediaDesktopSecond.banner_position,
            button_second_is_open:
              inputValueMediaDesktopSecond.banner_status_open === MENU_RENDER_VIEW_ENUM.NEW_TAB,
          },
          {
            intro_page_detail_type: "MOBILE",
            id_media_file_main: fileImages.imageMobileMain.id,
            id_media_file_button_first: fileImages.imageMobileFirst.id,
            button_first_name: inputValueMediaMobileFirst.banner_name,
            button_first_link: inputValueMediaMobileFirst.banner_link,
            button_first_location: inputValueMediaMobileFirst.banner_position,
            button_first_is_open:
              inputValueMediaMobileFirst.banner_status_open === MENU_RENDER_VIEW_ENUM.NEW_TAB,
            id_media_file_button_second: fileImages.imageMobileSecond.id,
            button_second_name: inputValueMediaMobileSecond.banner_name,
            button_second_link: inputValueMediaMobileSecond.banner_link,
            button_second_location: inputValueMediaMobileSecond.banner_position,
            button_second_is_open:
              inputValueMediaMobileSecond.banner_status_open === MENU_RENDER_VIEW_ENUM.NEW_TAB,
          },
        ],
      };

      const res = await introPageApi.create(payload);

      if (res.status < 300) {
        handleCloseModal();
        alertSuccess(t("อัพเดตข้อมูล"), t("อัพเดตข้อมูล สำเร็จ"), undefined, () => {
          handleGetData();
        });
      }
    } catch (err) {
      console.log(err);
      alertError(t("อัพเดตข้อมูล"), t("อัพเดตข้อมูล ไม่สำเร็จ"));
    } finally {
      dispatch(unsetLoading());
    }
  };

  const handleGetData = async () => {
    dispatch(setLoading());

    await introPageApi
      .getDataDetail()
      .then((res) => {
        if (res.status < 300) {
          const data = res?.data?.data || {};
          const baseFileUrl = process.env.REACT_APP_FILE_BASE_API;

          // Set main input values
          const startDate = new Date(data.intro_page_start);
          const endDate = new Date(data.intro_page_end);

          setInputValue({
            is_public: data.is_public,
            intro_start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
            intro_start_time: startDate ? moment(startDate).format("HH:mm") : "",
            intro_end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
            intro_end_time: endDate ? moment(endDate).format("HH:mm") : "",
          });

          // Map intro_page_details
          const desktop = data.intro_page_details.find(
            (d: any) => d.intro_page_detail_type === "DESKTOP"
          );
          const mobile = data.intro_page_details.find(
            (d: any) => d.intro_page_detail_type === "MOBILE"
          );

          // Desktop data
          if (desktop) {
            setInputValueDesktopFirst({
              banner_status_open: desktop.button_first_is_open ? MENU_RENDER_VIEW_ENUM.NEW_TAB : MENU_RENDER_VIEW_ENUM.CURRENT_TAB,
              banner_name: desktop.button_first_name || "",
              banner_link: desktop.button_first_link || "",
              banner_position: desktop.button_first_location || "",
            });

            setInputValueDesktopSecond({
              banner_status_open: desktop.button_second_is_open ? MENU_RENDER_VIEW_ENUM.NEW_TAB : MENU_RENDER_VIEW_ENUM.CURRENT_TAB,
              banner_name: desktop.button_second_name || "",
              banner_link: desktop.button_second_link || "",
              banner_position: desktop.button_second_location || "",
            });
          }

          // Mobile data
          if (mobile) {
            setInputValueMobileFirst({
              banner_status_open: mobile.button_first_is_open ? MENU_RENDER_VIEW_ENUM.NEW_TAB : MENU_RENDER_VIEW_ENUM.CURRENT_TAB,
              banner_name: mobile.button_first_name || "",
              banner_link: mobile.button_first_link || "",
              banner_position: mobile.button_first_location || "",
            });

            setInputValueMobileSecond({
              banner_status_open: mobile.button_second_is_open ? MENU_RENDER_VIEW_ENUM.NEW_TAB : MENU_RENDER_VIEW_ENUM.CURRENT_TAB,
              banner_name: mobile.button_second_name || "",
              banner_link: mobile.button_second_link || "",
              banner_position: mobile.button_second_location || "",
            });
          }

          // Handle preview file image URLs
          setFileImages({
            imageDesktopMain: {
              id: desktop?.media_main?.id_media_file || null,
              previewUrl: desktop?.media_main
                ? `${baseFileUrl}/${desktop.media_main.media_file_path}${desktop.media_main.media_file_name}`
                : null,
              filePath: desktop?.media_main?.media_file_path || null,
            },
            imageDesktopFirst: {
              id: desktop?.media_button_first?.id_media_file || null,
              previewUrl: desktop?.media_button_first
                ? `${baseFileUrl}/${desktop.media_button_first.media_file_path}${desktop.media_button_first.media_file_name}`
                : null,
              filePath: desktop?.media_button_first?.media_file_path || null,
            },
            imageDesktopSecond: {
              id: desktop?.media_button_second?.id_media_file || null,
              previewUrl: desktop?.media_button_second
                ? `${baseFileUrl}/${desktop.media_button_second.media_file_path}${desktop.media_button_second.media_file_name}`
                : null,
              filePath: desktop?.media_button_second?.media_file_path || null,
            },
            imageMobileMain: {
              id: mobile?.media_main?.id_media_file || null,
              previewUrl: mobile?.media_main
                ? `${baseFileUrl}/${mobile.media_main.media_file_path}${mobile.media_main.media_file_name}`
                : null,
              filePath: mobile?.media_main?.media_file_path || null,
            },
            imageMobileFirst: {
              id: mobile?.media_button_first?.id_media_file || null,
              previewUrl: mobile?.media_button_first
                ? `${baseFileUrl}/${mobile.media_button_first.media_file_path}${mobile.media_button_first.media_file_name}`
                : null,
              filePath: mobile?.media_button_first?.media_file_path || null,
            },
            imageMobileSecond: {
              id: mobile?.media_button_second?.id_media_file || null,
              previewUrl: mobile?.media_button_second
                ? `${baseFileUrl}/${mobile.media_button_second.media_file_path}${mobile.media_button_second.media_file_name}`
                : null,
              filePath: mobile?.media_button_second?.media_file_path || null,
            },
          });
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        dispatch(unsetLoading());
      });
  };

  useEffect(() => {
    handleGetData();
  }, []);

  return (
    <ContainerLayout
      title=""
      titleName={t("หน้าต้อนรับ")}
      navigateContent={
        <></>
      }
      buttonContent={
        <>
          <ContainerButton
            sxContainer={{
              display: "flex",
              justifyContent: "end",
            }}
            buttonData={[
              {
                seq: 1,
                buttonProps: {
                  onClick: () => navigate(routeName.cms_website.intro),
                },
                key: "BACK",
                label: t("ย้อนกลับ"),
                type: "BACK",
              },
              {
                seq: 2,
                hidden: !checkPermit.isUpdate,
                buttonProps: {
                  onClick: () => {
                    handleSubmit();
                  },
                },
                key: "SAVE",
                label: t("บันทึก"),
                type: "SAVE",
              },
            ]}
          />
          <ModalMedia
            open={modalState.open}
            handleClose={handleCloseModal}
            title={t("เพิ่มไฟล์")}
            id_media_file={
              modalState.currentUploadId
                ? fileImages[
                  modalState.currentUploadId as keyof FileImagesState
                ]?.id || null
                : null
            }
            onSelectMediaFile={handleSelectMediaFile}
            onSubmitMediaFile={handleSubmitMediaFile}
            onSubmitLocalFile={handleSubmitLocalFile}
          />


        </>
      }
      content={
        <div style={{ padding: "24px 40px" }}>

          <StateComponents
            otherProps={{ spacing: 2 }}
            typeProps={[
              {
                seq: 1,
                type: "SWITCH",
                gridProps: {
                  xs: 12,
                },
                fieldProps: {
                  checked: inputValue.is_public,
                  onChange: (val) =>
                    handleChangeInputValue("is_public", val),
                  label: t("สถานะการเผยแพร่"),
                },
              },
              {
                seq: 2,
                type: "DATE",
                gridProps: {
                  xs: 12,
                  md: 3,
                },
                fieldProps: {
                  required: true,
                  onChange: (date) =>
                    handleChangeInputValue("intro_start_date", date),
                  value: inputValue.intro_start_date,
                  heading: t("วันที่เริ่มต้นเผยแพร่"),
                  placeholder: t("ระบุ"),
                },
              },
              {
                seq: 3,
                type: "DATE",
                gridProps: {
                  xs: 12,
                  md: 3,
                },
                fieldProps: {
                  required: true,
                  disableStartDate: inputValue.intro_start_date,
                  onChange: (date) =>
                    handleChangeInputValue("intro_end_date", date),
                  value: inputValue.intro_end_date,
                  heading: t("วันที่สิ้นสุดเผยแพร่"),
                  placeholder: t("ระบุ"),
                },
              },
              {
                seq: 4,
                type: "TIME_PICKER",
                gridProps: {
                  xs: 12,
                  md: 3,
                },
                fieldProps: {
                  required: true,
                  value: inputValue.intro_start_time,
                  onChange: (e) =>
                    handleChangeInputValue("intro_start_time", e),
                  heading: t("เวลาที่เริ่มต้นเผยแพร่"),
                  placeholder: t("ระบุ"),
                },
              },
              {
                seq: 5,
                type: "TIME_PICKER",
                gridProps: {
                  xs: 12,
                  md: 3,
                },
                fieldProps: {
                  required: true,
                  value: inputValue.intro_end_time,
                  onChange: (e) => {
                    handleChangeInputValue("intro_end_time", e);
                  },
                  heading: t("เวลาที่สิ้นสุดเผยแพร่"),
                  placeholder: t("ระบุ"),
                },
              },
            ]}
          />

          <br />

          <Grid container spacing={2}>
            <Grid item lg={6} xs={12}>
              <b>{t("สำหรับ Desktop")}</b> {t("ขนาดภาพที่แนะนำ 1920x1080px")}
              <Grid container spacing={2}>
                <Grid item lg={12} xs={12}>
                  <UploadCard
                    id="imageDesktopMain"
                    height={300}
                    label={t("เพิ่มรูปภาพ")}
                    onUploadClick={handleUploadClick}
                    fileId={fileImages.imageDesktopMain.id}
                    previewUrl={fileImages.imageDesktopMain.previewUrl}
                  />
                </Grid>

                <Grid item lg={6} xs={12}>
                  <UploadCard
                    id="imageDesktopFirst"
                    height={175}
                    label={t("เพิ่มรูปภาพ")}
                    onUploadClick={handleUploadClick}
                    fileId={fileImages.imageDesktopFirst.id}
                    previewUrl={fileImages.imageDesktopFirst.previewUrl}
                  />

                  <FormSection
                    inputValue={inputValueMediaDesktopFirst}
                    setInputValue={setInputValueDesktopFirst}
                  />
                </Grid>

                <Grid item lg={6} xs={12}>
                  <UploadCard
                    id="imageDesktopSecond"
                    height={175}
                    label={t("เพิ่มรูปภาพ")}
                    onUploadClick={handleUploadClick}
                    fileId={fileImages.imageDesktopSecond.id}
                    previewUrl={fileImages.imageDesktopSecond.previewUrl}
                  />
                  <FormSection
                    inputValue={inputValueMediaDesktopSecond}
                    setInputValue={setInputValueDesktopSecond}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* mobile */}
            <Grid item lg={6} xs={12}>
              <b>{t("สำหรับ Mobile")}</b> {t("ขนาดภาพที่แนะนำ 393x852px")}
              <Grid container spacing={2}>
                <Grid item lg={4} xs={12}>
                  <UploadCard
                    id="imageMobileMain"
                    imageSize={120}
                    height={750}
                    label={t("เพิ่มรูปภาพ")}
                    onUploadClick={handleUploadClick}
                    fileId={fileImages.imageMobileMain.id}
                    previewUrl={fileImages.imageMobileMain.previewUrl}
                  />
                </Grid>

                <Grid item lg={8} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item lg={12} xs={12}>
                      <UploadCard
                        id="imageMobileFirst"
                        imageSize={50}
                        height={120}
                        label={t("เพิ่มรูปภาพ")}
                        onUploadClick={handleUploadClick}
                        fileId={fileImages.imageMobileFirst.id}
                        previewUrl={fileImages.imageMobileFirst.previewUrl}
                      />
                      <FormSection
                        inputValue={inputValueMediaMobileFirst}
                        setInputValue={setInputValueMobileFirst}
                      />
                    </Grid>
                    <Grid item lg={12} xs={12}>
                      <UploadCard
                        id="imageMobileSecond"
                        imageSize={50}
                        height={120}
                        label={t("เพิ่มรูปภาพ")}
                        onUploadClick={handleUploadClick}
                        fileId={fileImages.imageMobileSecond.id}
                        previewUrl={fileImages.imageMobileSecond.previewUrl}
                      />
                      <FormSection
                        inputValue={inputValueMediaMobileSecond}
                        setInputValue={setInputValueMobileSecond}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      }
    />
  );
};

export default WelcomePage;
